import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/observable/fromEvent';
import { MatDialog } from '@angular/material';

import { ModalIdleComponent } from './../components/modal-idle/modal-idle.component';

import { AppSettings } from '../app.settings';

@Injectable()
export class IdleService {

	// Mousedown event
	private mousedown$;
	// Set timeout for the time that activate status lasts.
	private activateTimeout;
	private autoSetActiveInterval;
	// Current idle status: active / idling
	public idleStatus = new BehaviorSubject('active');
	constructor(
		public dialog: MatDialog
	) { }
	setActive() {
		console.log('user active. re-count before idle.');
		if (this.activateTimeout) {
			clearTimeout(this.activateTimeout);
		}
		this.activateTimeout = setTimeout(() => {
			console.log('start idling');
			this.idleStatus.next('idling');
		}, AppSettings.idleTime);
	}
	initIdleMonitor() {
		console.log('initIdleMonitor()');
		this.idleStatus.next('active');
		// TODO:
		// this.resetActive(); // this will be set inside a3i component where idleStatus is subscribed.
		this.mousedown$ = Observable.fromEvent(document, 'mousedown');
		this.mousedown$.subscribe(() => {
			// If current status is still active, update token
			if (this.idleStatus.getValue() === 'active') {
				this.setActive();
			}
		});
	}
	stopIdleMonitor() {
		console.log('stopIdleMonitor()');
		clearTimeout(this.activateTimeout);
	}
	// Automatically renew. This is used for long service call processing.
	autoSetActive() {
		// Clear interval if already exists
		if (this.autoSetActiveInterval) {
			clearInterval(this.autoSetActiveInterval);
		}
		// Set active
		if (this.idleStatus.getValue() === 'active') {
			this.setActive();
		}
		this.autoSetActiveInterval = setInterval(() => {
			if (this.idleStatus.getValue() === 'active') {
				this.setActive();
			}
		}, AppSettings.idleTime - 10000);
	}
	// Stop automatically renew.
	stopAutoSetActive() {
		if (this.autoSetActiveInterval) {
			clearInterval(this.autoSetActiveInterval);
		}
	}
	openIdleWindow(successCallback?: Function) {

		const dialogRef = this.dialog.open(ModalIdleComponent, {
			width: '445px',
			height: '200px',
			data: {
			}
		});
		return dialogRef.afterClosed().subscribe((rsp) => {
			if (successCallback) {
				successCallback(rsp);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/idle.service.ts